module.exports = __webpack_public_path__ + "img/authorization-gas-fee.582274fd.svg";